import request from '@/utils/request'

export function getNotificationTemplates (data) {
  return request({
    url: '/api/admin/notification-templates',
    method: 'post',
    data: data
  })
}

export function showNotificationTemplate (data) {
  return request({
    url: '/api/admin/notification-templates/show',
    method: 'post',
    data: data
  })
}

export function updateNotificationTemplate (data) {
  return request({
    url: '/api/admin/notification-templates/update',
    method: 'post',
    data: data
  })
}
